"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebRequestLoginChallengeResponse = exports.WebRequestLoginChallengeRequest = exports.WebRequestLoginChallengeResponse_StatusCode = void 0;
/* eslint-disable */
const web_login_common_1 = require("./web_login_common");
const challenge_orchestration_common_1 = require("./challenge_orchestration_common");
const challenge_orchestration_challenge_data_1 = require("./challenge_orchestration_challenge_data");
const login_common_1 = require("./login_common");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/** Describes what happened with the request. */
var WebRequestLoginChallengeResponse_StatusCode;
(function (WebRequestLoginChallengeResponse_StatusCode) {
    /** UNSET - default value */
    WebRequestLoginChallengeResponse_StatusCode[WebRequestLoginChallengeResponse_StatusCode["UNSET"] = 0] = "UNSET";
    /** SUCCESS - challenge was successfully sent */
    WebRequestLoginChallengeResponse_StatusCode[WebRequestLoginChallengeResponse_StatusCode["SUCCESS"] = 1] = "SUCCESS";
    /**
     * ERR_GENERIC_FAILURE - Generic failure for backwards compatability of any new error types we add in future
     * client should not auto-retry, but can allow the user to retry
     */
    WebRequestLoginChallengeResponse_StatusCode[WebRequestLoginChallengeResponse_StatusCode["ERR_GENERIC_FAILURE"] = 10] = "ERR_GENERIC_FAILURE";
    /**
     * ERR_THROTTLED - the request was throttled by the service
     * client should not auto-retry but can retry the request
     */
    WebRequestLoginChallengeResponse_StatusCode[WebRequestLoginChallengeResponse_StatusCode["ERR_THROTTLED"] = 11] = "ERR_THROTTLED";
    /**
     * ERR_BLOCKED - the request for a login challenge is not allowed on this device, ip, or other reason
     * client can let user retry, but unlikely it will succeed
     */
    WebRequestLoginChallengeResponse_StatusCode[WebRequestLoginChallengeResponse_StatusCode["ERR_BLOCKED"] = 12] = "ERR_BLOCKED";
    /**
     * ERR_DENIED - the request for a login challenge was denied.
     * client can let user retry, but unlikely it will succeed
     */
    WebRequestLoginChallengeResponse_StatusCode[WebRequestLoginChallengeResponse_StatusCode["ERR_DENIED"] = 13] = "ERR_DENIED";
    WebRequestLoginChallengeResponse_StatusCode[WebRequestLoginChallengeResponse_StatusCode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(WebRequestLoginChallengeResponse_StatusCode = exports.WebRequestLoginChallengeResponse_StatusCode || (exports.WebRequestLoginChallengeResponse_StatusCode = {}));
function createBaseWebRequestLoginChallengeRequest() {
    return { webLoginHeader: undefined, unavailableChallenges: undefined };
}
exports.WebRequestLoginChallengeRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.webLoginHeader !== undefined) {
            web_login_common_1.WebLoginHeader.encode(message.webLoginHeader, writer.uint32(10).fork()).ldelim();
        }
        if (message.unavailableChallenges !== undefined) {
            challenge_orchestration_common_1.UnavailableChallenges.encode(message.unavailableChallenges, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebRequestLoginChallengeRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.webLoginHeader = web_login_common_1.WebLoginHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.unavailableChallenges = challenge_orchestration_common_1.UnavailableChallenges.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseWebRequestLoginChallengeRequest();
        message.webLoginHeader =
            object.webLoginHeader !== undefined && object.webLoginHeader !== null
                ? web_login_common_1.WebLoginHeader.fromPartial(object.webLoginHeader)
                : undefined;
        message.unavailableChallenges =
            object.unavailableChallenges !== undefined &&
                object.unavailableChallenges !== null
                ? challenge_orchestration_common_1.UnavailableChallenges.fromPartial(object.unavailableChallenges)
                : undefined;
        return message;
    },
};
function createBaseWebRequestLoginChallengeResponse() {
    return {
        statusCode: 0,
        authenticationSessionPayload: new Uint8Array(),
        payload: undefined,
        loginIdentifier: undefined,
    };
}
exports.WebRequestLoginChallengeResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.statusCode !== 0) {
            writer.uint32(8).int32(message.statusCode);
        }
        if (message.authenticationSessionPayload.length !== 0) {
            writer.uint32(18).bytes(message.authenticationSessionPayload);
        }
        if (message.payload?.$case === "challengeData") {
            challenge_orchestration_challenge_data_1.ChallengeData.encode(message.payload.challengeData, writer.uint32(26).fork()).ldelim();
        }
        if (message.payload?.$case === "errorData") {
            login_common_1.ErrorData.encode(message.payload.errorData, writer.uint32(34).fork()).ldelim();
        }
        if (message.loginIdentifier?.$case === "username") {
            writer.uint32(42).string(message.loginIdentifier.username);
        }
        if (message.loginIdentifier?.$case === "email") {
            writer.uint32(50).string(message.loginIdentifier.email);
        }
        if (message.loginIdentifier?.$case === "phoneNumber") {
            writer.uint32(58).string(message.loginIdentifier.phoneNumber);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebRequestLoginChallengeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.statusCode = reader.int32();
                    break;
                case 2:
                    message.authenticationSessionPayload = reader.bytes();
                    break;
                case 3:
                    message.payload = {
                        $case: "challengeData",
                        challengeData: challenge_orchestration_challenge_data_1.ChallengeData.decode(reader, reader.uint32()),
                    };
                    break;
                case 4:
                    message.payload = {
                        $case: "errorData",
                        errorData: login_common_1.ErrorData.decode(reader, reader.uint32()),
                    };
                    break;
                case 5:
                    message.loginIdentifier = {
                        $case: "username",
                        username: reader.string(),
                    };
                    break;
                case 6:
                    message.loginIdentifier = { $case: "email", email: reader.string() };
                    break;
                case 7:
                    message.loginIdentifier = {
                        $case: "phoneNumber",
                        phoneNumber: reader.string(),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseWebRequestLoginChallengeResponse();
        message.statusCode = object.statusCode ?? 0;
        message.authenticationSessionPayload =
            object.authenticationSessionPayload ?? new Uint8Array();
        if (object.payload?.$case === "challengeData" &&
            object.payload?.challengeData !== undefined &&
            object.payload?.challengeData !== null) {
            message.payload = {
                $case: "challengeData",
                challengeData: challenge_orchestration_challenge_data_1.ChallengeData.fromPartial(object.payload.challengeData),
            };
        }
        if (object.payload?.$case === "errorData" &&
            object.payload?.errorData !== undefined &&
            object.payload?.errorData !== null) {
            message.payload = {
                $case: "errorData",
                errorData: login_common_1.ErrorData.fromPartial(object.payload.errorData),
            };
        }
        if (object.loginIdentifier?.$case === "username" &&
            object.loginIdentifier?.username !== undefined &&
            object.loginIdentifier?.username !== null) {
            message.loginIdentifier = {
                $case: "username",
                username: object.loginIdentifier.username,
            };
        }
        if (object.loginIdentifier?.$case === "email" &&
            object.loginIdentifier?.email !== undefined &&
            object.loginIdentifier?.email !== null) {
            message.loginIdentifier = {
                $case: "email",
                email: object.loginIdentifier.email,
            };
        }
        if (object.loginIdentifier?.$case === "phoneNumber" &&
            object.loginIdentifier?.phoneNumber !== undefined &&
            object.loginIdentifier?.phoneNumber !== null) {
            message.loginIdentifier = {
                $case: "phoneNumber",
                phoneNumber: object.loginIdentifier.phoneNumber,
            };
        }
        return message;
    },
};
//# sourceMappingURL=web_request_login_challenge.js.map